import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgTwitter({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.963 5.672c-.324.68-.882 1.164-1.443 1.62-.346.281-.43.571-.453.995-.256 4.848-2.377 8.59-6.84 10.668-3.712 1.728-7.458 1.457-11.05-.55-.073-.04-.17-.062-.174-.229 1.458.103 2.873-.083 4.209-.695.548-.25 1.09-.52 1.635-.991-.273-.054-.47-.089-.663-.133-1.36-.31-2.333-1.1-2.94-2.353-.146-.3-.14-.457.268-.422.381.033.767.007 1.175-.054-1.876-.747-2.975-2.023-3.07-4.127.591.175 1.089.439 1.75.425-.854-.724-1.433-1.533-1.633-2.572-.194-1.016-.073-1.974.485-2.93.776.867 1.564 1.637 2.482 2.263 1.687 1.151 3.55 1.808 5.572 2.037.346.039.516.017.468-.426-.19-1.747.481-3.13 1.969-4.034 1.51-.916 3.106-.9 4.525.15.673.498 1.212.52 1.887.216.438-.198.88-.383 1.448-.629-.347.942-.86 1.618-1.697 2.184.781.005 1.397-.325 2.053-.45l.037.037z"
        fill={color}
      />
    </svg>
  )
}

export default SvgTwitter
